import Sidebar from '@templates/Sidebar';
import SidebarMobile from '@templates/SidebarMobile';
import Header from '@templates/Header';
import { Outlet } from 'react-router-dom';
import 'react-tooltip/dist/react-tooltip.css';
import { Tooltip } from 'react-tooltip';
import SvgIcons from '@modules/SvgIcons';
import { Bounce, ToastContainer } from 'react-toastify';

export default function Layout() {
  return (
    <>
      <div className="relative flex flex-row bg-white md:bg-grayColory">
        <div className="max-md:hidden fixed top-0 left-0 right-0 z-50 w-full text-center flex items-center justify-center bg-success text-white py-1">
          <p className="text-xs md:text-sm">" این یک نسخه نمونه کار است و داده‌ها فیک و غیرقابل تغییر هستند. "</p>
        </div>
        <div className="h-screen">
          <Sidebar />
        </div>
        <div className="w-full flex flex-col max-sm:m-0 overflow-hidden h-screen relative">
          <div className="border-b-[1px] border-blackFont-200 bg-white px-7 py-7 max-sm:py-3.5 max-sm:px-4">
            <Header />
          </div>
          <div className="w-full md:bg-gray overflow-y-auto h-[calc(100dvh-158px)] md:h-full md:p-5 mx-auto scrollNone">
            <Outlet />
          </div>
          <SidebarMobile />
        </div>
      </div>
      <Tooltip id="my-tooltip" />
      <Tooltip id="my-tooltip-click" openOnClick={true} />
      <SvgIcons />
      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar={true}
        closeOnClick={true}
        rtl={false}
        draggable
        transition={Bounce}
        stacked={window.innerWidth > 768 ? true : false}
        icon={false}
        closeButton={false}
        style={{
          top: '32px', // فاصله از بالا
          left: '50%',
          transform: 'translateX(-50%)',
          width: '90%', // برای موبایل بهتر
          // maxWidth: "300px", // جلوگیری از بزرگ‌تر شدن از این مقدار
        }}
      />
    </>
  );
}
